
document.addEventListener('DOMContentLoaded', function () {
    const thumbnails = document.querySelectorAll('.product--thumbnails-left .thumbnail-list__item');

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('data-target');
            if (!targetId) return;

            const targetElement = document.getElementById(`Slide-${targetId}`);

            if (targetElement) {
                // Scroll to the element with a slight offset for sticky headers if needed
                // The CSS scroll-margin-top is the best way to handle offset, implementing here purely for trigger
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });

        // Also attach to the button inside just in case event bubbling is stopped or target is button
        const button = thumbnail.querySelector('button');
        if (button) {
            button.addEventListener('click', function (e) {
                // Stop the default theme slider logic which might try to scroll horizontally
                e.stopPropagation();
                e.preventDefault();

                // Trigger the click logic on the parent `li` which has the data attribute
                const parentLi = this.closest('.thumbnail-list__item');
                if (parentLi) {
                    const targetId = parentLi.getAttribute('data-target');
                    if (!targetId) return;
                    const targetElement = document.getElementById(`Slide-${targetId}`);
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            });
        }
    });
});
